
<template>
  <div>
    <Class v-for="schoolClass in classes" :key="schoolClass.$id" :schoolid="school" :classid="schoolClass.$id"></Class>
  </div>
</template>

<script>
import {fetchSchool,fetchClassesOfSchool} from '../firebase/firebase'
import Class from './Class.vue'

export default {
  name: "classes",
  components:{
    Class
  },
  props:['schoolid'],
  data() {
      return {
          unsubscribe: null,
          unsubscribeClasses: null,
          name: "",
          classes: [],
          school: "e5abIXEqXZc3x5I0hYhd"
    }
  },
  async created() {
    console.log("SCHOOL ID:", this.school)

    this.name = (await fetchSchool(this.school).get()).data.name;

    const data = (await fetchClassesOfSchool(this.school).get());
    this.classes = data.docs.map(doc => {
        const $data = doc.data();
        return {
          $id: doc.id,
          ...$data
        };
      });
    console.log("CLASSES", this.classes)
  },
  destroyed() {
    if(this.unsubscribe){
      this.unsubscribe()
    }
    if(this.unsubscribeClasses){
      this.unsubscribeClasses()
    }
  }
};
</script>